import { JOB_TYPE_EXPERIENCE } from "@root/shared/utils/constants";

// 売上力診断で除外する経験ID
export const EXCLUDE_EXPERIENCE_IDS = [
  JOB_TYPE_EXPERIENCE.ESTHETICIAN_SCHOOL_GRADUATE_ID,
  JOB_TYPE_EXPERIENCE.NAILIST_SCHOOL_GRADUATE_ID,
  JOB_TYPE_EXPERIENCE.BIYOSHI_SCHOOL_GRADUATE_ID,
  JOB_TYPE_EXPERIENCE.EYELIST_SCHOOL_GRADUATE_ID,
  JOB_TYPE_EXPERIENCE.THERAPIST_SCHOOL_GRADUATE_ID,
] as const;

// 各ステップの定数
export const STEP = {
  START: "start", // 診断スタートページ
  BASIC_INFO: "basicInfo", // 基本情報
  JOB_TYPE: "jobType", // 職種
  EXPERIENCE: "experience", // 経験
  CREDENTIALS: "credentials", // 資格
  MONTHLY_CUSTOMERS: "monthlyCustomers", // 月間顧客数
  MONTHLY_NOMINATED_CUSTOMERS: "monthlyNominatedCustomers", // 月間指名顧客数
  AVERAGE_SPENDING: "averageSpending", // 平均単価
  PERSONAL_SALES: "personalSales", // 個人売上
  ACCOUNT: "account", // メールアドレス・パスワード
} as const;

// STEPの値の型
export type StepValue = (typeof STEP)[keyof typeof STEP];

// ステップの順序（STEPの定義順序から自動生成）
export const STEP_ORDER = Object.values(STEP) as StepValue[];

// TODO: @root/constants/jobTypes から JOB_TYPE を import するように修正してください
// 職種ID定数
export const ESTHETICIAN_JOB_TYPE_ID = "1";
export const NAILIST_JOB_TYPE_ID = "2";
export const BIYOSHI_JOB_TYPE_ID = "3";
export const EYELIST_JOB_TYPE_ID = "5";
export const THERAPIST_JOB_TYPE_ID = "7";

// 資格選択が必要な職種ID（美容師・アイリスト）
export const CREDENTIAL_REQUIRED_JOB_TYPE_IDS = [BIYOSHI_JOB_TYPE_ID, EYELIST_JOB_TYPE_ID] as const;

// 資格ID定数
export const COSMETOLOGIST_LICENSE_CREDENTIAL_ID = "23"; // 美容師免許
export const SUPERVISOR_COSMETOLOGIST_CREDENTIAL_ID = "24"; // 管理美容師

// jobType別のバリデーションルール定義
type ValidationRule = {
  min: number;
  max: number;
};

export type JobTypeValidationRules = {
  monthlyCustomers: ValidationRule;
  averageSpending: ValidationRule;
  personalSales: ValidationRule;
};

export const JOB_TYPE_VALIDATION_RULES: Record<string, JobTypeValidationRules> = {
  [ESTHETICIAN_JOB_TYPE_ID]: {
    monthlyCustomers: { min: 1, max: 350 },
    averageSpending: { min: 2000, max: 120000 },
    personalSales: { min: 2000, max: 7100000 },
  },
  [NAILIST_JOB_TYPE_ID]: {
    monthlyCustomers: { min: 1, max: 350 },
    averageSpending: { min: 1500, max: 30000 },
    personalSales: { min: 1500, max: 1800000 },
  },
  [BIYOSHI_JOB_TYPE_ID]: {
    monthlyCustomers: { min: 1, max: 700 },
    averageSpending: { min: 1000, max: 50000 },
    personalSales: { min: 1000, max: 2400000 },
  },
  [EYELIST_JOB_TYPE_ID]: {
    monthlyCustomers: { min: 1, max: 350 },
    averageSpending: { min: 2500, max: 30000 },
    personalSales: { min: 2500, max: 2100000 },
  },
  [THERAPIST_JOB_TYPE_ID]: {
    monthlyCustomers: { min: 1, max: 350 },
    averageSpending: { min: 2000, max: 100000 },
    personalSales: { min: 2000, max: 5900000 },
  },
} as const;
